import StoreMenuGroupModel from './StoreMenuGroupModel';
import StoreBusinessTimeModel from './StoreBusinessTimeModel';
import StoreMenuModel from './StoreMenuModel';
import StoreToppingGroupModel from './StoreToppingGroupModel';
import StoreToppingModel from './StoreToppingModel';
import StoreSetMenuGroupModel from './StoreSetMenuGroupModel';
import StoreSetMenuModel from './StoreSetMenuModel';
import { generateEventMap } from '../util';

export default class StoreModel {
  companyId;
  storeCode;
  culture;
  storeName;
  storeCEO;
  storePhone;
  storeAddress1;
  storeAddress2;
  businessNumber;
  tax1_type;
  tax1_percent;
  tax2_type;
  tax2_percent;
  isTaxBeforeDiscount;
  takeoutTaxType;
  eatinTaxType;
  deliveryTaxType;
  useable;
  orderType;
  deliveryFee;
  addressInputMethod;
  addressHelperText;
  paymentType;
  isPointUseable;
  useableMinimumPoint;
  merchantID2;
  merchantID;
  extraKey;
  paymentMethod;
  businessTimes;
  orderMethod;
  isEzwelPayUsed;
  ezwelPaySchemeType;
  isLangButtonUsed;
  notation;
  isCouponUsed;
  isRecommendedMenuUsed;
  isDeliveryCodeChecked;
  theme;
  isRequestInputUsed;

  recommendedMenus;
  menuGroups;
  menus;
  toppingGroups;
  toppings;
  setMenuGroups;
  setMenus;
  eventMap;

  constructor(data) {
    Object.assign(this, data);
    this.businessTimes =
      data.businessTimes === undefined || data.businessTimes.length === 0
        ? []
        : data.businessTimes.map(businessTime => new StoreBusinessTimeModel(businessTime));
    this.menuGroups = data.allMenuGroups ? data.allMenuGroups.map(menuGroup => new StoreMenuGroupModel(menuGroup)) : [];
    this.menus = data.allMenus ? data.allMenus.map(menu => new StoreMenuModel(menu)) : [];
    this.toppingGroups = data.allToppingGroups
      ? data.allToppingGroups.map(toppingGroup => new StoreToppingGroupModel(toppingGroup))
      : [];
    this.toppings = data.allToppings ? data.allToppings.map(topping => new StoreToppingModel(topping)) : [];
    this.setMenuGroups = data.allSetMenuGroups
      ? data.allSetMenuGroups.map(setMenuGroup => new StoreSetMenuGroupModel(setMenuGroup))
      : [];
    this.setMenus = data.allSetMenus ? data.allSetMenus.map(setMenu => new StoreSetMenuModel(setMenu)) : [];
    this.eventMap = generateEventMap(data.events, data.eventItems);
  }
}
